export default "__VITE_ASSET__fd6e5626__"